import NotificationActions from '../Actions/NotificationActions';

function displayError(messages: string[], title = 'Unable to process your action') {
    NotificationActions.notificationReceived({
        icon: 'warning sign',
        severity: 'failure',
        title: title,
        messages: messages
    });
    console.log('Displaying errors:\n**' + title + '**\n' + messages.map(e => '- ' + e).join('\n'));
}

function displayGenericError() {
    displayError(['An unexpected error has occurred and the eCargo technical team has been notified. If you continue to encounter issues, please email support@ecargo.co.nz with a screenshot and a description of what you were doing when you encountered this issue.']);
}

function throwError(errorMessage: string) {
    displayGenericError();
    throw new Error(errorMessage);
}

// Based on the 'PublicFacingWebApiError' class in C#.
type FrontEndApiErrorDetails = {
    errorType: string;
    reason: string;
    possibleSolution: string;
    activityId: string;
    errorDetails: string[];
};

function displayServerError(result: FrontEndApiErrorDetails) {
    if(result && result.errorType === 'ValidationFailed') {
        displayError(result.errorDetails, "Validation failed");
    }
    else if(result && result.reason) {
        console.log('Error response received: ' + JSON.stringify(result));
        displayError([[result.reason, result.possibleSolution].join(' ').trim()]);
    }
    else {
        displayGenericError();
    }
}

// Based on error created in 'rejectRequest' in FrontEndApi.js.
type FrontEndApiError = {
    response: Response;
    handled: boolean;
    responseObject?: FrontEndApiErrorDetails;
};

// There is a possiblilty that this may be called with an error that is not FrontEnd Api related.
// This new type has been introduced to maintain backwards compatability for the function 'handleError'.
// It allows us to proceed with migrating this file from Javascript to TypeScript and minimises any behavioural changes.
type NonFrontEndApiError = {
    handled?: boolean;
};

function handleError(e: FrontEndApiError | NonFrontEndApiError) {
    const response = "response" in e ? e.response : undefined;

    if(response && response.bodyUsed === false) {
        response.json().then(displayServerError, displayGenericError);
    }
    else {
        displayGenericError();
    }

    e.handled = true;
}

function clearError() {
    NotificationActions.clearNotifications();
}

export default { handleError, displayError, clearError, throwError };
